import { DocumentNode } from '@apollo/client'
import { JsonObject } from '@ts/json'
import { object as objectFromDotNotation } from 'dot-object'
import { cloneDeep, get, omit } from 'lodash'
import { UiSchema } from 'react-jsonschema-form'

export const nestedObjectFromDotNotation = (formData: JsonObject) => {
  const result = cloneDeep(formData)
  objectFromDotNotation(result)
  return result
}

export function mergeNestedPayloads<T extends JsonObject>(
  result: { [key: string]: T },
  key: string
): JsonObject {
  return Object.keys(result).reduce<{ [key: string]: T }>((prev, current) => {
    const payload = get(result, `${current}.${key}`)
    return payload ? { ...prev, ...payload } : prev
  }, {})
}

export const removeReadOnlyFields = (formData: JsonObject, uiSchema: UiSchema) => {
  const readOnlyFields = Object.keys(uiSchema).filter(fieldKey => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const schemaDefn = uiSchema[fieldKey]
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return typeof schemaDefn === 'object' && !!schemaDefn['ui:readonly']
  })
  return omit(formData, readOnlyFields)
}

export const payloadFieldNameFromMutation = (mutation: DocumentNode) =>
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  get(mutation, 'definitions[0].selectionSet.selections[0].name.value')
